import { useMemo } from 'react'
import { documentationRootGuid } from '@constants'
import { Divider, Stack } from '@mui/material'
import { Form2 } from '@ui/forms'
import BaseFormFields from '../../../BaseFormFields'
import FormFields from './components/FormFields'

type DefaultValues = WordFileItemConfig

interface Props {
  item: FileItem
  mutate: (data: WordFileItemConfig) => void
}

const WordFileInfo = ({ item, mutate }: Props) => {
  const defaultValues = useMemo(() => {
    const baseConfig: DefaultValues = {
      ...(item.additional_data ?? {}),
      item_guid: item.guid,
      name: item.name,
      preamble: item?.additional_data?.preamble ?? '',
    }

    return baseConfig
  }, [item])

  return (
    <Stack spacing={2} p={1}>
      <Form2
        key={JSON.stringify(defaultValues)}
        onSubmit={(data: DefaultValues) => {
          mutate(data)
        }}
        defaultValues={defaultValues}
        submitOnChange
      >
        <Stack spacing={2}>
          <BaseFormFields
            elementGuid={item.element_guid}
            showBeginOnNewPage={item.parent_guid !== documentationRootGuid}
          />

          <Divider />

          <FormFields />
        </Stack>
      </Form2>
    </Stack>
  )
}

export default WordFileInfo
